<template>
    <el-popover
        placement="bottom"
        trigger="click"
        @hide="hidePopperSearch(valueHere)">
        <div class="th-filter-down" slot="reference">
            <slot name="icon">
                <i :class="['el-icon-arrow-down', iconActive ? 'el-icon-arrow-down-active' : '']"></i>
            </slot>
        </div>
        <el-input
            class="input-with-select"
            v-model="valueHere"
            size="medium"
            :placeholder="placeholder||$t('admin.enterKeyword')"
            clearable
        ></el-input>
    </el-popover>
</template>
<script>
export default {
    name: 'InputPopover',
    props: {
        hidePopperSearch: {
            type: Function,
            default: () => {}
        },
        value: {
            type: String,
            default: null
        },
        placeholder: {
            type: String,
            default: null
        },
    },
    data() { return {
        valueHere: ''
    }},
    created() {
    },
    methods: {
        onValueChange() {
            this.$emit('update:value', this.valueHere)
            this.hidePopperSearch(this.valueHere)
        }
    },
    watch: {
        valueHere(v) {
            this.$emit('update:value', v)
        },
        value(v) {
            this.valueHere = v
        }
    },
    computed: {
        iconActive() {
            if (this.rangeSelect) {
                return this.valueHere && this.valueHere.some(v => v !== '')
            } else {
                return this.valueHere
            }
        }
    }
}
</script>
